export default "__VITE_ASSET__c747e144__"